/** Агрегат по одной площадке: число предложений и минимальная цена. */
export interface OfferPluginStat {
  id: number;
  count: number;
  minCost: number | null;
}

/** Число из смешанного значения бэка (строка «99.13» / «1 000» или число). */
export function toOfferNumber(value: unknown): number {
  if (typeof value === "number") return value;
  if (typeof value === "string") {
    const parsed = Number(value.replace(",", ".").replace(/\s/g, ""));
    return Number.isFinite(parsed) ? parsed : 0;
  }
  return 0;
}

/**
 * Дешёвая сигнатура набора офферов (длина + ключи plugin_id:pos_idx:cost).
 * Одинаковая сигнатура двух соседних поллов живого обновления означает, что
 * данные не изменились — грид можно не трогать, избегая лишних пересборок и
 * «дёрганья» таблицы. Принимает и офферы group_search, и zakooper-проценки.
 */
export function offersSignature(
  list: ReadonlyArray<{ plugin_id?: unknown; pos_idx?: unknown; cost?: unknown }>,
): string {
  let sig = String(list.length);
  for (const offer of list) {
    sig += `|${toOfferNumber(offer.plugin_id)}:${toOfferNumber(offer.pos_idx)}:${toOfferNumber(offer.cost)}`;
  }
  return sig;
}

/**
 * Статистика предложений по площадкам (кол-во, мин. цена), отсортированная по
 * убыванию количества. Общая для офферов group_search и zakooper-проценки.
 */
export function computeOfferPluginStats(offers: { plugin_id?: unknown; cost?: unknown }[]): OfferPluginStat[] {
  const map = new Map<number, OfferPluginStat>();
  for (const offer of offers) {
    const id = toOfferNumber(offer.plugin_id);
    const cost = toOfferNumber(offer.cost);
    const entry = map.get(id) ?? { id, count: 0, minCost: null };
    entry.count += 1;
    if (cost > 0 && (entry.minCost === null || cost < entry.minCost)) {
      entry.minCost = cost;
    }
    map.set(id, entry);
  }
  return [...map.values()].sort((a, b) => b.count - a.count);
}
